import { z } from 'zod'

import { parseJSONDate } from '@/shared/lib/date-fns/parse-json-date'

export const UserMuteSchema = z.object({
    expire_time: z.string().transform(parseJSONDate).nullable(),
})

export type UserMute = z.infer<typeof UserMuteSchema>

export function isUserMuted(mute?: UserMute, now: number = Date.now()): mute is UserMute {
    // no mute
    if (!mute) {
        return false
    }

    // permanent mute
    if (mute.expire_time === null) {
        return true
    }

    // temporary mute
    const expireTime = mute.expire_time.getTime()
    if (expireTime > now) {
        return true
    }

    // mute expired
    return false
}
